import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
  Grid,
} from '@mui/material';
import Alert from '@mui/material/Alert';

const DeleteFavoriteHotelDialog = ({
  open,
  onClose,
  hotelName,
  isLoading,
  isShowAlert,
  alertOptions,
  onDelete,
  onAlertClose,
}) => (
  <Dialog open={open} onClose={onClose} disableRestoreFocus>
    <DialogTitle>Eliminar hotel favorito</DialogTitle>
    <DialogContent>
      {isLoading ? (
        <Grid style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress color="primary" />
        </Grid>
      ) : isShowAlert ? (
        <Alert severity={alertOptions.type}>{alertOptions.msg}</Alert>
      ) : (
        <Typography variant="body1">
          ¿Está seguro que desea eliminar de la lista de favoritos el hotel{' '}
          <span style={{ textTransform: 'capitalize' }}>
            &quot;{String(hotelName)?.toLowerCase()}&quot;?
          </span>
        </Typography>
      )}
    </DialogContent>
    {!isLoading && (
      <DialogActions>
        {isShowAlert ? (
          <Button
            onClick={onAlertClose}
            variant="contained"
            style={{ backgroundColor: 'green', color: 'white' }}
          >
            Aceptar
          </Button>
        ) : (
          <>
            <Button
              onClick={onClose}
              variant="contained"
              style={{ backgroundColor: 'red', color: 'white' }}
            >
              Cancelar
            </Button>
            <Button
              onClick={onDelete}
              variant="contained"
              style={{ backgroundColor: 'green', color: 'white' }}
            >
              Eliminar de la lista
            </Button>
          </>
        )}
      </DialogActions>
    )}
  </Dialog>
);

export default DeleteFavoriteHotelDialog;
